import "./CustomInputSelector.0.css";
import { filter } from "lodash-es";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER, INJECT_UICORE_RENDERER, NO_OP } from "../../../../../lib/utils/consts";
// 用来让用户选择备选组件的

const __script_base__ = {
  name: 'CustomInputSelector',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    },
    renderer: {
      from: INJECT_UICORE_RENDERER,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      resolveFn: NO_OP,
      presets: {}
    };
  },
  watch: {
    visible() {
      setTimeout(() => {
        if (this.visible) return;

        // reset
        this.presets = {};
        this.visible = false;
        this.resolveFn = NO_OP;
      }, 300);
    }
  },
  methods: {
    /**
     * 询问用户使用哪个备选组件，返回一个 Promise，resolve 后可能是
     *
     * - undefined 放弃操作
     * - "default" 默认
     * - UICore.ComponentFitDataResult 一个具体的替代信息
     *
     * @public
     */
    askForCustomInput({
      path
    }) {
      return new Promise(resolve => {
        this.resolveFn = resolve;
        this.visible = true;

        /** @type {UICore.ComponentFitDataResult[]} */
        const rawans = this.uc.fitData(path, this.renderer);
        const answer = {
          editor: {
            title: '编辑器组件',
            items: []
          },
          'editor-alt': {
            title: '编辑器组件(非常用)',
            items: []
          },
          display: {
            title: '展示型组件',
            items: []
          }
        };
        rawans.forEach(x => {
          if (x.type in answer) answer[x.type].items.push(x);
        });
        this.presets = filter(answer, x => x.items.length > 0);
      });
    },
    handleCancel() {
      this.resolveFn();
      this.visible = false;
    },
    handleUserSelect(value) {
      this.resolveFn(value);
      this.visible = false;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a-modal', {
    attrs: {
      "title": "自定义输入框组件",
      "visible": _vm.visible,
      "footer": null,
      "width": "700px",
      "dialog-class": "uccis-dialog"
    },
    on: {
      "cancel": _vm.handleCancel
    }
  }, [_c('div', {
    staticClass: "uccis-group"
  }, [_c('h2', {
    staticClass: "uccis-groupTitle"
  }, [_vm._v("\n      将输入框组件换成什么?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "uccis-item",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function ($event) {
        return _vm.handleUserSelect('default');
      }
    }
  }, [_c('div', {
    staticClass: "uccis-name"
  }, [_vm._v("\n        系统自动 (默认)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "uccis-desc"
  }, [_vm._v("\n        使用默认的编辑框组件\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "uccis-item",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function ($event) {
        return _vm.handleUserSelect('empty');
      }
    }
  }, [_c('div', {
    staticClass: "uccis-name"
  }, [_vm._v("\n        自由设计\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "uccis-desc"
  }, [_vm._v("\n        需要你自行拖拽一个组件进去，然后自行做数据绑定\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "uccis-groupFooter"
  }, [_vm._v("\n      也可以选用下面推荐的组件...\n    ")])]), _vm._v(" "), _vm._l(_vm.presets, function (g, gid) {
    return _c('div', {
      key: gid,
      staticClass: "uccis-group"
    }, [_c('h2', {
      staticClass: "uccis-groupTitle"
    }, [_vm._v("\n      " + _vm._s(g.title) + "\n    ")]), _vm._v(" "), _vm._l(g.items, function (it, idx) {
      return _c('div', {
        key: gid + ":" + idx,
        staticClass: "uccis-item",
        attrs: {
          "tabindex": "0"
        },
        on: {
          "click": function ($event) {
            return _vm.handleUserSelect(it);
          }
        }
      }, [_c('div', {
        staticClass: "uccis-name"
      }, [_vm._v("\n        " + _vm._s(it.name) + "\n      ")]), _vm._v(" "), _c('div', {
        staticClass: "uccis-desc"
      }, [_vm._v("\n        " + _vm._s(it.desc) + "\n      ")])]);
    })], 2);
  })], 2);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Field/comps/CustomInputSelector.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);